import { useBeforeAfterContent } from './useBeforeAfterContent'
import { useContactContent } from './useContactContent'
import useElementOnScreen from './useElementOnScreen'
import { useFooterData } from './useFooterData'
import { useHeaderData } from './useHeaderData'
import useMediaQuery from './useMediaQuery'
import { useRatingsContent } from './useRatingsContent'
import { useReviewContent } from './useReviewContent'
import { useStepsContent } from './useStepsContent'
import { useTeamData } from './useTeamData'
import { useTreatmentCategories } from './useTreatmentCategories'
import { useTrustMarks } from './useTrustMarks'

export const useElementonScreen = useElementOnScreen
export const useContactcontent = useContactContent
export const useFooterdata = useFooterData
export const useHeaderdata = useHeaderData
export const useMediaquery = useMediaQuery
export const useRatingscontent = useRatingsContent
export const useReviewcontent = useReviewContent
export const useStepscontent = useStepsContent
export const useTeamdata = useTeamData
export const useTreatmentcategories = useTreatmentCategories
export const useTrustmarks = useTrustMarks
export const useBeforeaftercontent = useBeforeAfterContent
